import React, { useEffect, useState } from "react"
import { Modal, Button } from "react-bootstrap"

const IdleTimeOutModal = () => { 
  // eslint-disable-next-line no-unused-vars
  const [messageBoxVisible, setMessageBoxVisible] = useState(true)
  const [displayWarn, setDisplayWarn] = useState(false)
  const [warningTime] = useState(900000) // 900000 = 15mins = 900 seconds
  let warnTimeout
  const title = "Page Expired"

  const [displayRemind, setDisplayRemind] = useState(false)
  const [reminderTime] = useState(600000) // 600000 = 10mins = 600 seconds
  let remindTimeout
  const remindTitle = "Page About Expire"

  const warn = () => {
    setDisplayWarn(true)
  }
  const remind = () => {
    setDisplayRemind(true)
  }

  const setTimeouts = () => {
    warnTimeout = setTimeout(warn, warningTime)
    remindTimeout = setTimeout(remind, reminderTime)
  }

  const clearTimeouts = () => {
    if (warnTimeout) clearTimeout(warnTimeout)
    if (remindTimeout) clearTimeout(remindTimeout)
  }
  useEffect(() => {
    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ]

    const resetTimeout = () => {
      clearTimeouts()
      setTimeouts()
    }

    for (let i in events) {
      window.addEventListener(events[i], resetTimeout)
    }

    setTimeouts()
    return () => {
      for (let i in events) {
        window.removeEventListener(events[i], resetTimeout)
        clearTimeouts()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (displayRemind && !displayWarn) {
    return (
      <Modal
        show={messageBoxVisible}
        onHide={() => {}}
        centered={true}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop={true}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>{remindTitle || " "}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className={"content-body"}
            dangerouslySetInnerHTML={{
              __html: "You are idle for 10 minutes, click 'Extend' to continue your session",
            }}
          ></div>
        </Modal.Body>
        <Modal.Footer className="justify-content-end">
          <Button
            className="floatRight themeColorButton"
            // variant="warning"
            onClick={
              () => {
                clearTimeouts();
                setDisplayRemind(false);
              }
            }
          >
            Extend
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  if (displayWarn) {
    return (
      // <MessageBox
      //   show={messageBoxVisible}
      //   onClose={() => setMessageBoxVisible(false)}
      //   content={"Page expired due to inactivity on page."}
      //   isIdleTimeout={true}
      //   title={"Page Expired"}
      // />

      <Modal
        show={messageBoxVisible}
        onHide={() => {}}
        centered={true}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop={true}
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            <h5>{title || " "}</h5>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className={"content-body"}
            dangerouslySetInnerHTML={{
              __html: "Page expired due to inactivity on page.",
            }}
          ></div>
        </Modal.Body>
        <Modal.Footer className="justify-content-end">
          <Button
            className="floatRight themeColorButton"
            // variant="warning"
            onClick={
              () =>
                (window.location.href =
                  window.location.href) /*eslint no-self-assign: ["error", {"props": false}]*/
            }
          >
            Refresh Page
          </Button>
        </Modal.Footer>
      </Modal>
    )
  }

  return <div></div>
}
export default IdleTimeOutModal
